export default {
  userAccount: {},
  billingData: [],
  cards: {
    status: '',
  },
  fwdAddrList: {},
  smsService: {},
  userStats: {},
  jointAccounts: [],
  notarizeList: [],
  phoneList: [],
  userPlan: {},
  form1583Signed: false
};
